import { render } from "./SshAddPrivateKey.vue?vue&type=template&id=507e9b3c&scoped=true"
import script from "./SshAddPrivateKey.vue?vue&type=script&lang=js"
export * from "./SshAddPrivateKey.vue?vue&type=script&lang=js"

import "./SshAddPrivateKey.vue?vue&type=style&index=0&id=507e9b3c&scoped=true&lang=css"
/* custom blocks */
import block0 from "./SshAddPrivateKey.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507e9b3c"]])

export default __exports__